// Ambang batas
const BATAS_MIN = 3000000;
const NISHOB = 7640144;
const PEMBULATAN_KOMPONEN = 500;
const PEMBULATAN_M = 1000;
const PEMBULATAN_SETORAN = 1000;

const ceilToMultiple = (value, multiple) => Math.ceil(value / multiple) * multiple;
const floorToMultiple = (value, multiple) => Math.floor(value / multiple) * multiple;

export const hitungKomponenDariPendapatan = (pendapatan) => {
  if (pendapatan === undefined || pendapatan === null) return null;
  const p = Number(pendapatan);
  
  let ibk, ibs, ibp, ibks, iip;
  if (p >= BATAS_MIN) {
    ibk = 0.015 * p;
    ibs = 0.005 * p;
    ibp = 0.02 * p;
    ibks = 0.005 * p;
  } else {
    ibk = 15000;
    ibs = 0;
    ibp = 0;
    ibks = 0;
  }
  iip = p >= NISHOB ? 0.025 * p : 0;
  
  ibk = ceilToMultiple(ibk, PEMBULATAN_KOMPONEN);
  ibs = ceilToMultiple(ibs, PEMBULATAN_KOMPONEN);
  ibp = ceilToMultiple(ibp, PEMBULATAN_KOMPONEN);
  ibks = ceilToMultiple(ibks, PEMBULATAN_KOMPONEN);
  iip = ceilToMultiple(iip, PEMBULATAN_KOMPONEN);
  
  const totalKomponen = ibk + ibs + ibp + ibks + iip;
  let iuranBulanan = ceilToMultiple(totalKomponen, PEMBULATAN_M);
  let lainnya = iuranBulanan - totalKomponen;
  
  if (p < BATAS_MIN) {
    iuranBulanan = 15000;
    lainnya = 0;
  }
  
  return {
    ibk, ibs, ibp, ibks, iip,
    totalKomponen,
    lainnya,
    iuranBulanan,
    iuranIDI: iip,
  };
};

export const estimasiPendapatanDariM = (M_target) => {
  if (!M_target || M_target <= 0) return 0;
  let low = 0, high = 100000000, best = 0, bestError = Infinity;
  for (let iter = 0; iter < 100; iter++) {
    const mid = (low + high) / 2;
    const { iuranBulanan } = hitungKomponenDariPendapatan(mid);
    const error = Math.abs(iuranBulanan - M_target);
    if (error < bestError) { bestError = error; best = mid; }
    if (iuranBulanan < M_target) low = mid;
    else high = mid;
    if (error < 1) break;
  }
  return Math.round(best);
};

export const hitungSetoran = (pendapatan, iuranIDI_N, iuranBulanan_M, iuranGasibu = 0) => {
  const komp = hitungKomponenDariPendapatan(pendapatan);
  if (!komp) return null;
  
  const setoranPusatKotor = 
    komp.ibk +
    komp.ibs +
    komp.ibp * 0.75 +
    komp.ibks +
    komp.iip +
    (iuranIDI_N || 0);
  
  const gasibu = Number(iuranGasibu) || 0;
  const totalSetoranAnggota = (iuranBulanan_M || komp.iuranBulanan) + (iuranIDI_N || 0);
  let setoranPusatKomponen = floorToMultiple(setoranPusatKotor, PEMBULATAN_SETORAN);
  let kasKelas = totalSetoranAnggota - setoranPusatKomponen;
  
  if (kasKelas % 1000 !== 0) {
    const kasKelasBulat = floorToMultiple(kasKelas, 1000);
    setoranPusatKomponen = totalSetoranAnggota - kasKelasBulat;
    kasKelas = kasKelasBulat;
  }
  let setoranPusat = setoranPusatKomponen + gasibu;
  if (setoranPusat < 0) setoranPusat = 0;
  if (kasKelas < 0) kasKelas = 0;
  
  return {
    setoranPusat,
    gasibu,
    kasKelas,
    ...komp,
  };
};